import { ErrorMessage } from "formik";
import React from "react";
import AsyncSelect from "react-select/async";
import Select, { createFilter } from "react-select";

const filterConfig =  {
  ignoreCase: true,
  matchFrom: 'any', //start
  stringify: option => `${option.label} ${option.value}`,
  trim: true,
}


const AppSelectFormik = ({
  name: fieldName,
  label = "",
  labelId = "",
  variant = "async", // simple
  //### for async variant ###
  cacheOptions = false,
  defaultOptions = [],
  loadOptions = (input) => new Promise(()=>{}),
  //###########################
  isSearchable = true,
  options = [],
  placeholder = "Select...",
  isClearable = false,
  id = "",
  disabled = false,
  ...rest
}) => {
  const handleBlur = () => {
    setTimeout(() => {
      rest.setFieldTouched(fieldName, true);
    }, 100);
  };

  const handleChange = (value) => {
    rest.setFieldValue(fieldName, value);
  };

  return (
    <React.Fragment>
      {label && (
        <label
          style={{
            fontSize: "0.95rem",
            marginTop: "3px",
            marginRight: "14px",
            marginLeft: "14px",
          }}
          htmlFor={fieldName}
          id={labelId ? labelId : `${fieldName}-label`}>
          {label}
        </label>
      )}
      {variant === "async" ? (
        <AsyncSelect
          cacheOptions={cacheOptions}
          defaultOptions={defaultOptions}
          name={fieldName}
          id={id ? id : fieldName}
          placeholder={placeholder}
          isClearable={isClearable}
          loadOptions={loadOptions}
          getOptionLabel={(item) => `${item.value} - ${item.label}`}
          value={rest.values[fieldName]}
          onBlur={handleBlur}
          onChange={handleChange}
          isDisabled={disabled}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 100 }),
            control: (base, state) => ({ ...base, minHeight: 45 }),
          }}
        />
      ) : (
        <Select
          getOptionLabel={(item) => `${item.value} - ${item.label}`}
          isSearchable={isSearchable}
          isClearable={isClearable}
          name={fieldName}
          id={id ? id : fieldName}
          placeholder={placeholder}
          value={rest.values[fieldName]}
          onBlur={handleBlur}
          onChange={handleChange}
          isDisabled={disabled}
          options={options}
          filterOption={createFilter(filterConfig)}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 100 }),
            control: (base, state) => ({ ...base, minHeight: 45 }),
          }}
        />
      )}
      <ErrorMessage
        name={fieldName}
        component={(props) => (
          <div
            style={{
              color: "#f44336",
              fontSize: "0.75rem",
              lineHeight: "1.66",
              marginTop: "3px",
              marginRight: "14px",
              marginLeft: "14px",
            }}>
            {props.children}
          </div>
        )}
      />
    </React.Fragment>
  );
};

export default AppSelectFormik;
